import script from "./gameCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./gameCenter.vue?vue&type=script&setup=true&lang=js"

import "./gameCenter.vue?vue&type=style&index=0&id=1de5b2d7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1de5b2d7"]])

export default __exports__